<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>액션 활동 관리 상세</h2>
                <div>
                    <button class="default_btn _blue" @click="toggleModify">활동 수정</button>
                    <button class="default_btn _gray" @click="router.replace(`/action/${state.groupIdx}/state`)">활동 목록</button>
                </div>
            </div>
            <div class="state_info">
                <div>
                    <span class="sch_list_tit">제목</span>
                    <div>
                        <input type="text" id="state_title" v-model="state.title" />
                    </div>
                </div>
                <div>
                    <span class="sch_list_tit">상태</span>
                    <div v-if="state.info.state === 1"><button class="table_btn _blue" @click="stateChange">진행중</button></div>
                    <div v-else><button class="table_btn _gray" @click="stateChange">종료</button></div>
                </div>
                <div>
                    <span class="sch_list_tit">활동 기간</span>
                    <div>
                        <input type="date" id="state_start_date" v-model="state.startDate" @blur="changeDate" />
                        ~
                        <input type="date" id="state_end_date" v-model="state.endDate" @blur="changeDate" />
                    </div>
                </div>
                <div>
                    <span class="sch_list_tit">등록일</span>
                    <p>{{ CommonUtils.dateFormat(new Date(state.info.createDate), ".", false) }}</p>
                </div>
            </div>
            <div class="sch_condition_wrap">
                <div class="left _column _flex">
                    <div class="_flex _align_bottom _multi">
                        <div class="select_date_wrap">
                            <div class="select_date">
                                <input type="date" @keydown.enter="searchDate" name="" id="" v-model="search.startDate" @change="getList" />
                            </div>
                            <div class="select_date">
                                <input
                                    style="margin-left: 5px"
                                    type="date"
                                    @keydown.enter="searchDate"
                                    name=""
                                    id=""
                                    v-model="search.endDate"
                                    @change="getList"
                                />
                            </div>
                        </div>
                        <div class="radio_wrap sch_list" style="height: 100%">
                            <label for="isNoticeAll">
                                <input
                                    id="isNoticeAll"
                                    name="isNotice"
                                    type="radio"
                                    :value="null"
                                    v-model="state.isNotice"
                                    @change="
                                        state.currentPage = 1;
                                        getList();
                                    "
                                />
                                <em></em>
                                <span>전체</span>
                            </label>

                            <label class="checkbox_wrap2" for="isNotice">
                                <input
                                    style="margin-right: 5px"
                                    type="radio"
                                    id="isNotice"
                                    v-model="state.isNotice"
                                    :value="1"
                                    @change="
                                        state.currentPage = 1;
                                        getList();
                                    "
                                />
                                <em></em>
                                <span class="is_notice">공지글</span>
                            </label>
                        </div>

                        <!-- 액션 활동 관리 -->
                        <div class="search_wrap search_action">
                            <input type="text" placeholder="제목을 입력하세요." v-model="search.keyword" @keyup.enter="getList" />
                            <button type="button" class="search_btn icon_wrap" @click="getList">
                                <img src="img/search_btn.png" alt="" />
                            </button>
                        </div>
                    </div>
                </div>

                <div class="right _align_bottom _flex">
                    <div class="info_box">
                        <div>
                            총 활동 수
                            <span class="col_blue">{{ CommonUtils.numberFormat(state.totalLength) }}개</span>
                        </div>
                    </div>
                    <template v-if="state.info.state === 1">
                        <button type="button" class="default_btn _blue" @click="actionModal">공지 등록</button>
                        <button type="button" class="default_btn _gray" @click="isDeleteForAction">삭제</button>
                    </template>

                    <button type="button"><img src="img/excel_icon.png" alt=" 엑셀 다운로드" @click="downloadExcel" /></button>
                </div>
            </div>
            <!-- 액션 활동 관리 -->
            <div class="common_table custom_scroll medium">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 100px" />
                        <col />
                        <col style="width: 100px" />
                        <col style="width: 140px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 100px" />
                        <col style="width: 180px" />
                        <col style="width: 180px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                <input type="checkbox" v-model="state.isCheckAll" @change="toggleAll()" />
                            </th>
                            <th>번호</th>
                            <th>제목</th>
                            <th>첨부파일 유무</th>
                            <th>작성자</th>
                            <th>조회수</th>
                            <th>공지 여부</th>
                            <th>비밀글 여부</th>
                            <th>등록일</th>
                            <th>수정일</th>
                            <th>수정</th>
                        </tr>
                    </thead>

                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_main' + item.idx" @click.stop>
                                        <input type="checkbox" :id="'chk_main' + item.idx" v-model="state.idxList" :value="item.idx" @click.stop />
                                    </label>
                                </td>
                                <td class="text_center">{{ (state.currentPage - 1) * state.perPage + (idx + 1) }}</td>
                                <td class="ellipsis_1 underline">
                                    <a :href="`${state.userSiteUrl}/#/actionView/${state.idx}/${item.idx}`" target="_blank">
                                        {{ item.title }}
                                    </a>
                                </td>
                                <td class="cnt">
                                    <img v-if="item.fileList && item.fileList.length > 0" src="img/file-clip.png" alt="O" style="width: 16px" />
                                </td>
                                <td class="cnt">{{ item.writer }}</td>
                                <td class="cnt">{{ !item.viewCnt ? 0 : CommonUtils.numberFormat(item.viewCnt) }}</td>
                                <td class="cnt"><img v-if="item.isNotice === 1" src="img/megaphone-fill.png" alt="O" /></td>
                                <td class="cnt"><img v-if="item.isSecret === 1" src="img/lock-filled.png" alt="O" /></td>
                                <td class="cnt">{{ item.createDate ? CommonUtils.dateFormat(new Date(item.createDate), ".", true) : "-" }}</td>
                                <td class="cnt">{{ item.updateDate ? CommonUtils.dateFormat(new Date(item.updateDate), ".", true) : "-" }}</td>
                                <td class="cnt p_5">
                                    <button
                                        type="button"
                                        class="table_btn _blue"
                                        @click="
                                            state.actionIdx = item.idx;
                                            state.isShowActionModal = true;
                                        "
                                    >
                                        상세
                                    </button>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="10">
                                <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.currentPage"
                :totalLength="state.totalLength"
                :perPage="state.perPage"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>
    <ModalDefault
        v-if="state.isShowModal"
        :type="modal.tab"
        :title="modal.title"
        :content="modal.content"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ActionModal
        v-if="state.isShowActionModal"
        :stateIdx="state.idx"
        :idx="state.actionIdx"
        @close="state.isShowActionModal = false"
        @callback="
            state.isShowActionModal = false;
            getList();
        "
    ></ActionModal>
</template>
<script lang="ts" config>
    import {
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        FormListModal,
        ActionModal,
        useRoute,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: {
            Header,
            Left,
            ModalDefault,

            PageBtn,
            FormListModal,

            ActionModal,
        },
        setup() {
            const route = useRoute();
            const state = reactive({
                groupIdx: 0 as number,
                idx: 0 as number,
                actionIdx: 0 as number,

                isShowSearchType: false as boolean,
                isShowModal: false as boolean,
                isShowActionModal: false as boolean,

                isNotice: null as number | null,
                isCheckAll: false as boolean,
                idxList: [] as number[],

                info: {} as types.ResActionState,
                list: [] as types.ResBoardActionVOForApi[],

                totalLength: 0 as number,
                perPage: 10 as number,
                currentPage: 1 as number,

                userSiteUrl: process.env.VUE_APP_USER_FRONT_ADDRESS,

                title: "" as string,
                startDate: "" as string,
                endDate: "" as string,
            });

            const modal = reactive({
                title: "" as string,
                content: "" as string,
                tab: 0 as number,
                gubun: 0 as number,
            });

            const search = reactive({
                startDate: "",
                endDate: "",
                keyword: "",
                searchType: { name: "전체", key: "" } as { name: string; key: string },
            });

            const selectOption = [
                { name: "전체", key: "" },
                { name: "진행중", key: "" },
                { name: "종료", key: "" },
            ];

            onMounted(() => {
                if (route.params.groupidx) state.groupIdx = Number(route.params.groupidx);
                if (route.params.idx) {
                    state.idx = Number(route.params.idx);
                    getDetail();
                    getList();
                }
            });

            watch(
                () => state.idxList,
                () => {
                    state.isCheckAll = state.idxList.length === state.list.length;
                },
            );

            const getDetail = async () => {
                const res = await apiService.actionState.detail(state.idx);
                if (res.returnCode === 0) {
                    state.info = res.data;
                    state.title = res.data.name;
                    state.startDate = CommonUtils.dateFormat(new Date(res.data.startDate), "-", false);
                    state.endDate = CommonUtils.dateFormat(new Date(res.data.endDate), "-", false);
                } else {
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getList = async () => {
                const param: types.ReqBoardActionList = {
                    page: state.currentPage,
                    size: state.perPage,
                    searchType: search.searchType.key,
                    searchText: search.keyword,
                    startDate: search.startDate,
                    endDate: search.endDate,
                    isNotice: state.isNotice!,
                };

                const res = await apiService.boardAction.list(state.idx, param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalLength = 0;
                }
            };

            const searchDate = async () => {
                if (search.startDate && search.endDate && search.endDate < search.startDate) {
                    search.endDate = "";
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
                search.startDate = search.startDate;
                search.endDate = search.endDate;
                state.currentPage = 1;
                getList();
            };

            const downloadFile = async () => {};

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getList();
            };

            const callBackModal = (param: any) => {
                if (param.action === "confirm") {
                    if (modal.gubun === 1) toggleState();
                    else if (modal.gubun === 2) modify();
                } else if (param.action === "confirmRemoveForAdmin") {
                    remove();
                }
                state.isShowModal = false;
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const toggleAll = () => {
                if (state.isCheckAll) {
                    state.idxList = state.list.map((item) => item.idx);
                } else {
                    state.idxList = [];
                }
            };

            const stateChange = () => {
                if (state.info.state === 1) {
                    modal.tab = 5;
                    modal.title = "알림";
                    modal.content = "액션 활동을 종료 하시겠습니까?";
                    modal.gubun = 1;
                    state.isShowModal = true;
                } else toggleState();
            };

            const toggleState = async () => {
                const res = await apiService.actionState.change(state.groupIdx, state.idx);
                if (res.returnCode === 0) {
                    getDetail();
                } else {
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const actionModal = async () => {
                state.actionIdx = 0;
                state.isShowActionModal = true;
            };

            const isDeleteForAction = () => {
                if (state.idxList && state.idxList.length > 0) {
                    modal.tab = 10;
                    modal.title = "알림";
                    modal.content = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const remove = async () => {
                const param = { idxList: state.idxList.join(", ") };
                const res = await apiService.boardAction.remove(param);
                if (res.returnCode === 0) {
                    getList();
                } else {
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const downloadExcel = async () => {
                try {
                    const param: types.ReqBoardActionForExcel = {
                        searchType: search.searchType.key,
                        searchText: search.keyword,
                        startDate: search.startDate,
                        endDate: search.endDate,
                        isNotice: state.isNotice!,
                        idxList: String(state.idxList),
                    };

                    let res = await apiService.boardAction.exportExcel(state.idx, param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        modal.tab = -1;
                        modal.title = "알림";
                        modal.content = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
            };

            const toggleModify = () => {
                modal.tab = 5;
                modal.title = "알림";
                modal.content = "액션 활동을 수정 하시겠습니까?";
                modal.gubun = 2;
                state.isShowModal = true;
            };

            const checkValue = () => {
                if (!state.title) {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "제목을 입력해주세요";
                    return false;
                } else if (!state.startDate || !state.endDate) {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "활동기간을 입력해주세요";
                    return false;
                } else if (state.startDate && state.endDate && state.endDate < state.startDate) {
                    state.isShowModal = true;
                    state.endDate = "";
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "날짜를 올바르게 선택해주세요.";
                    return false;
                }
                return true;
            };

            const modify = async () => {
                state.isShowModal = false;
                if (!checkValue()) return;
                const param = {
                    title: state.title,
                    startDate: state.startDate,
                    endDate: state.endDate,
                } as types.ReqActionState;
                const res = await apiService.actionState.modify(state.groupIdx, state.idx, param);
                if (res.returnCode == 0) {
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "수정이 완료되었습니다.";
                    state.isShowModal = true;
                    getDetail();
                } else {
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const changeDate = async () => {
                if (state.startDate && state.endDate && state.endDate < state.startDate) {
                    state.endDate = "";
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
            };

            return {
                CommonUtils,
                router,
                state,
                modal,
                search,
                selectOption,
                searchDate,
                downloadFile,
                handlePageChange,
                callBackModal,
                closeModal,
                stateChange,
                getList,
                actionModal,
                isDeleteForAction,
                toggleAll,
                downloadExcel,
                toggleModify,
                changeDate,
            };
        },
    };
</script>
<style scoped>
    .sch_condition_wrap > div.right {
        align-items: center;
    }
    .box_tit > div button + button {
        margin-left: 10px;
    }
</style>
